export default "__VITE_ASSET__CHlQhPbR__"